import { Auth } from 'aws-amplify';
import awsConfig from '../aws-exports';
import { Dayjs } from 'dayjs';

export interface PlayFactoryRequest {
	contentType: string;
	contentSelector: string;
	contentId: string;
}

export interface DeliveryEndpoint {
	url: string;
	cdn: string;
}

export interface Expiration {
	date: Dayjs;
	expired: boolean;
}

export interface MediaUrls {
	videoUrl?: string;
	licenseUrl?: string;
	expirations?: {
		media?: Expiration;
		license?: Expiration;
	};
}

export interface PlayFactoryResponse {
	deliveryEndpoints: DeliveryEndpoint[];
	licenseAcquisitionUrl: string;
	expirations: {
		deliveryEndpoints: string;
		licenseAcquisitionUrl: string;
	};
}

export const fetchPlayFactoryVideo = async (
	contentId: string,
	contentType = 'EVENT',
	contentSelector = 'EME-CENC-HLS'
): Promise<PlayFactoryResponse> => {
	const currentSession = await Auth.currentSession();
	const jwtToken = currentSession.getIdToken().getJwtToken();

	const proxyUrl = `${awsConfig.licenseAcquisitionEndpointUrl}/play-factory/play-privileged`;

	const requestBody: PlayFactoryRequest = {
		contentType,
		contentSelector,
		contentId
	};

	const response = await fetch(proxyUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${jwtToken}`
		},
		body: JSON.stringify(requestBody)
	});

	if (!response.ok) {
		const errorText = await response.text();
		throw new Error(`Play Factory API error: ${response.status} - ${errorText}`);
	}

	const data: PlayFactoryResponse = await response.json();
	return data;
};


export const isPlayFactoryAvailable = (): boolean => {
	return !!awsConfig.licenseAcquisitionEndpointUrl;
};
